import { IPersonalInformationData } from '../components/Checkout/PersonalInformation';
import { ICreditCard, ICreditCardData } from '../models/CreditCard';
import { InmateAccountPayment } from '../models/InmateAccountPayment';
import { IMobilePaymentRequest } from '../utils/applePay';
import Api, { IPaginatedResponse } from '../services/api';

export function index(page = 1, perPage = 250) {
  return Api
    .get<IPaginatedResponse<InmateAccountPayment>>({
      url: '/inmate-account-payment',
      query: { page, perPage }
    });
}

export function audioVideoIndex(page = 1, perPage = 250) {
  return Api
    .get<IPaginatedResponse<InmateAccountPayment>>({
      url: '/inmate-account-payment/audio-video',
      query: { page, perPage }
    });
}

type InmateAccountPaymentRequestData = {
  payment: {
    accountType: 'wallet' | 'audio-video'
    facilityId: number
    inmateId: number
    amount: number
    receiptEmailAddress: string
  }
  cardSecurityCode: string
  savedCreditCardId?: number | null
  newCreditCard: ICreditCardData | null
  mobilePaymentRequest?: IMobilePaymentRequest | null
  purchaserDetails: IPersonalInformationData
  recaptchaToken: string
}

type InmateAccountPaymentResponse = {
  success: boolean
  payment: InmateAccountPayment
}

/**
 * Returns the elements to send to the API for the payment. If we are
 * working with a mobile payment request, we'll filter out the saved and new
 * card fields. Otherwise a partially filled request can break validation on API.
 */
export function getCardPaymentRequestData(
  savedCreditCard: ICreditCard | null | undefined,
  creditCard: ICreditCardData | null | undefined,
  mobilePaymentRequest: IMobilePaymentRequest | null | undefined
): Pick<
  InmateAccountPaymentRequestData,
  'savedCreditCardId' | 'cardSecurityCode' | 'newCreditCard' | 'mobilePaymentRequest'
> {
  if (mobilePaymentRequest) {
    return {
      savedCreditCardId: null,
      cardSecurityCode: '',
      newCreditCard: null,
      mobilePaymentRequest
    };
  }

  return {
    savedCreditCardId: savedCreditCard ? savedCreditCard.id : null,
    cardSecurityCode: creditCard?.cardSecurityCode ?? '',
    newCreditCard: savedCreditCard ? null : creditCard ?? null,
    mobilePaymentRequest: mobilePaymentRequest ?? null
  };
}

export function post(paymentRequest: InmateAccountPaymentRequestData) {
  return Api
    .post<InmateAccountPaymentResponse>({
      url: '/inmate-account-payment',
      data: paymentRequest
    })
}

export function get(id: number) {
  return Api
    .get<InmateAccountPayment>({
      url: `/inmate-account-payment/${id}`
    })
}

export function getAudioVideo(id: number) {
  return Api
    .get<InmateAccountPayment>({
      url: `/inmate-account-payment/audio-video/${id}`
    })
}